// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import store from "./store";
// import Antd from 'ant-design-vue';
import Http from "./utils/request";
import 'ant-design-vue/dist/antd.less';

import {message} from "ant-design-vue";
//import "./common/css/color.less"

Vue.use(Http);

import {
  Select,
  Button
} from "ant-design-vue";

Vue.use(Select).use(Button)

import VueCropper from 'vue-cropper';
Vue.use(VueCropper);

Vue.prototype.$message = message;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js